import axios, { type AxiosError } from 'axios';
import { i18n } from '@/lib/i18n';
import { isArray } from 'lodash';
import { toast } from 'sonner';
import { API_ROUTES } from '@/api/routes';

export const processApiError = (error: unknown, showToast: boolean = true) => {
  const status = (error as AxiosError)?.response?.status;
  const requestURL = (error as AxiosError)?.config?.url ?? null;

  const is401whileLoggedIn =
    status === 401 &&
    requestURL !== API_ROUTES.authentication.login &&
    requestURL !== API_ROUTES.authentication.logout;

  let message = i18n.t('errors.somethingWentWrong');

  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message?: unknown }).message === 'string'
  ) {
    message = (error as { message: string }).message;
  }

  if (axios.isAxiosError(error)) {
    if (error?.response?.data?.message) {
      message = error.response.data.message;
    } else if (error?.response?.data?.error) {
      message = error.response.data.error;
    } else if (error.message) {
      message = error.message;
    }
  }

  if (showToast && !is401whileLoggedIn) {
    toast.error(isArray(message) && message.length ? message[0] : message);
  }

  return message;
};
